import MainSettings from "./MainSettings";
const CustomComponents = [
    {
        name: "mainSettings",
        component: MainSettings
    }
];

export default CustomComponents;
